/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiContainer, ApiImportExternalErpItemsRequest, ApiImportableContainer } from '@Model';
import type { HttpActions, ListInfo, ListRequest, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of ExternalErpContainersController.
 */
export class ExternalErpContainersRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls POST /external_erp/containers:query
     */
    public getImportableContainers(listRequest: ListRequest): Promise<Result<ListInfo<ApiImportableContainer>>> {
        return this.http.post<Result<ListInfo<ApiImportableContainer>>, ListRequest>('/external_erp/containers:query', listRequest);
    }

    /**
     * Calls POST /external_erp/containers:import
     */
    public importContainers(request: ApiImportExternalErpItemsRequest): Promise<Result<ApiContainer[]>> {
        return this.http.post<Result<ApiContainer[]>, ApiImportExternalErpItemsRequest>('/external_erp/containers:import', request);
    }
}
